// extracted by mini-css-extract-plugin
module.exports = {"modalmini":"ChangeOrDelHabbit_modalmini__1j-nv","btn__modal":"ChangeOrDelHabbit_btn__modal__3HscF"};